module.exports = __webpack_public_path__ + "static/img/all-auction-img.6efde0b4.jpg";